(function () {
	"use strict";
    angular.module("cardFrontConsumer.areas.sales.reviewOrder", []);
}());